module.exports = __webpack_public_path__ + "static/media/img_panel_sitevisit.2a7c5f3c.jpg";